import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme, { menuIsOpen: boolean; menuWidth?: number }>(theme => ({
  dropdownArrow: {
    transform: props => (props.menuIsOpen ? 'rotate(180deg)' : ''),
    transition: 'transform 250ms linear',
  },
  menuContent: {
    margin: theme.spacing(1, 0),
    padding: 0,
  },
  menuRoot: {
    border: theme.customBorders.gray300,
    borderRadius: theme.misc.borderRadius,
    boxShadow: theme.customShadows.shadow4,
    maxWidth: '100%',
    width: props => props && props.menuWidth,
  },
}));

export default useStyles;
